/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiBillingFromJSON, ApiBillingToJSON, } from './ApiBilling';
export function ApiListBillingsResponseFromJSON(json) {
    return ApiListBillingsResponseFromJSONTyped(json, false);
}
export function ApiListBillingsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'billings': !exists(json, 'billings') ? undefined : (json['billings'].map(ApiBillingFromJSON)),
    };
}
export function ApiListBillingsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'billings': value.billings === undefined ? undefined : (value.billings.map(ApiBillingToJSON)),
    };
}
